"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
// tslint:disable:max-classes-per-file
var $dyn;
(function ($dyn) {
    var controls;
    (function (controls) {
        /** Client implementation of X++ WrappedTextControl control. */
        var WrappedTextControl = /** @class */ (function (_super) {
            __extends(WrappedTextControl, _super);
            function WrappedTextControl(data, element, parent, role) {
                return _super.call(this, data, element, parent, role) || this;
            }
            return WrappedTextControl;
        }($dyn.ui.Control));
        controls.WrappedTextControl = WrappedTextControl;
        var WrappedTextControlCell = /** @class */ (function (_super) {
            __extends(WrappedTextControlCell, _super);
            function WrappedTextControlCell(data, element, parent, role) {
                return _super.call(this, data, element, parent, role) || this;
            }
            return WrappedTextControlCell;
        }(WrappedTextControl));
        controls.WrappedTextControlCell = WrappedTextControlCell;
        $dyn.cellAdapter({ id: "WrappedTextControl" });
    })(controls = $dyn.controls || ($dyn.controls = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=WrappedTextControl.js.map
